import { I18n } from '@calendly/i18n';
import { ProTip } from '@calendly/ui/components/pro-tip';
import classNames from 'classnames';
import { forwardRef } from 'react';
import previewImage from './preview.png';
const previewerContainerCss = "p4q5ek7";
const PreviewerContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-component="domain-setting-preview-container" className={classNames(previewerContainerCss, props.className)} />;
});
const domainSettingPreviewImageCss = "db7udf7";
const DomainSettingPreviewImage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = previewImage;
  const alt = 'Preview image';
  return <Component ref={ref} {...restProps} src={src} alt={alt} data-component="domain-setting-preview-image" className={classNames(domainSettingPreviewImageCss, props.className)} />;
});
export const DomainControlSettingPreview = () => <PreviewerContainer>
    <ProTip>
      {I18n.t('publisher.organization_settings.domain_control.domain_control_settings.preview_description')}
      <DomainSettingPreviewImage />
    </ProTip>
  </PreviewerContainer>;

require("./setting_preview.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./setting_preview.js");